var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Delete_1560851",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M6,10.667a2.174,2.174,0,0,0,2.182,2.167V23.667A4.349,4.349,0,0,0,12.545,28H23.455a4.349,4.349,0,0,0,4.364-4.333V12.833A2.174,2.174,0,0,0,30,10.667V8.5a2.174,2.174,0,0,0-2.182-2.167H23.455V4.167A2.174,2.174,0,0,0,21.273,2H14.727a2.174,2.174,0,0,0-2.182,2.167V6.333H8.182A2.174,2.174,0,0,0,6,8.5Zm19.636,13a2.174,2.174,0,0,1-2.182,2.167H12.545a2.174,2.174,0,0,1-2.182-2.167V12.833H25.636ZM14.727,4.167h6.545V6.333H14.727ZM8.182,8.5H27.818v2.167H8.182Z",
    transform: "translate(-6 -2)",
    fill: "#888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M31.091,58.667a1.087,1.087,0,0,0,1.091-1.083v-6.5a1.091,1.091,0,0,0-2.182,0v6.5A1.087,1.087,0,0,0,31.091,58.667Z",
    transform: "translate(-23.455 -37)",
    fill: "#888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M47.091,58.667a1.087,1.087,0,0,0,1.091-1.083v-6.5a1.091,1.091,0,0,0-2.182,0v6.5A1.087,1.087,0,0,0,47.091,58.667Z",
    transform: "translate(-35.091 -37)",
    fill: "#888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M63.091,58.667a1.087,1.087,0,0,0,1.091-1.083v-6.5a1.091,1.091,0,0,0-2.182,0v6.5A1.087,1.087,0,0,0,63.091,58.667Z",
    transform: "translate(-46.727 -37)",
    fill: "#888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.332cf4bd.svg";
export { ForwardRef as ReactComponent };